import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'
import type { TMbaCafeLunchCartLine } from '@/types/cart'

export const mbaCafeLunch = async (studentAccountId: TStudentAccountId) => {
  const response = await new Request().get('/ajax/student/' + studentAccountId + '/mba_cafe_lunch')
  return Util.Obj.keysToCamel(response.data.items) as TMbaCafeLunchCartLine[]
}
